import Vue from "vue";
import $ from "jquery";

import { Component, Watch } from "vue-property-decorator";
import { StatuAbsenceSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/StatuAbsenceSalarieDto";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { EventBus } from "../Controls/EventBus";
import ListeDesDemandes from "./listeDesDemandes/listeDesDemandes";
import SituationDesAbsences from "./situationDesAbsences/situationDesAbsences";
import ModalDetailAbsence from "./modals/modalDetailAbsence/modalDetailAbsence";
import ModalAjouterAbsence from "./modals/modalAjouterAbsence/modalAjouterAbsence";
import ModalChangerEtatAbsence from "./modals/modalChangerEtatAbsence/modalChangerEtatAbsence";
import { SalarieConnecteDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieConnecteDto";
import { ParametresInstance } from "../Controls/Parameters";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import Calendrier from "../calendrier/calendrier";
import { TypeCalendrier } from '../../shared/models/typeCalendrier';
import { ActionAbsencesEnum } from "../../dto/GenApi.iNotPaie.Dto/ActionAbsencesEnum";
import { AbsenceSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { UtilisateurConnecteDto } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurConnecteDto";
import { ModeOuvertureAbsence } from "../../shared/models/AbsenceEnum";

@Component({
	components: {
		CalendrierComponent: require("../calendrier/calendrier.vue.html"),
		ListeDesDemandes: require("./listeDesDemandes/listeDesDemandes.vue.html"),
		SituationDesAbsences: require("./situationDesAbsences/situationDesAbsences.vue.html"),
		ModalDetailAbsence: require("./modals/modalDetailAbsence/modalDetailAbsence.vue.html"),
		ModalAjouterAbsence: require("./modals/modalAjouterAbsence/modalAjouterAbsence.vue.html"),
		ModalChangerEtatAbsence: require("./modals/modalChangerEtatAbsence/modalChangerEtatAbsence.vue.html")
	},
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as GestionDesAbsences);
			/// TODO test et redirect si nécessaire
			if (ParametresInstance.societeCourante != undefined && !ParametresInstance.societeCourante.IsModeCongeActive) {
				window.location.href = "https://www.genapi.fr/offre-talent.htm";
			}

			if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
				vm.fetchData();
			}
		});
	}
})
export default class GestionDesAbsences extends Vue {
	public isSwitchManagerVisible = false;
	public isModeManager = false;
	public salarieConnecte?: SalarieConnecteDto = undefined;

	public modalDetailAbsence?: ModalDetailAbsence = undefined;
	public modalAjouterAbsence?: ModalAjouterAbsence = undefined;
	public modalChangerEtatAbsence?: ModalChangerEtatAbsence = undefined;

	public calendrier?: Calendrier = undefined;
	public listeDesDemandes?: ListeDesDemandes = undefined;
	public situationDesAbsences?: SituationDesAbsences = undefined;

	public aucunUtilisateurAssocie = false;
	public paieEnable?: boolean = false;

	public dataReady = 0;
	public listeEquipe?: StatuAbsenceSalarieDto[] = undefined;
	public anyTeam = false;
	public estValideurExterne = false;
	public typeCalendrierEspaceSalarie = TypeCalendrier.EspaceSalarie;
	public typeCalendrierEspaceValideurSalarie = TypeCalendrier.EspaceValideurSalarie;
	public typeCalendrierEspaceValideurExterne = TypeCalendrier.EspaceValideurExterne;
	public currentType = TypeCalendrier.EspaceSalarie;
	public loadCalendar = true

	public mounted(): void {
		this.calendrier = this.$refs.calendrierComponent as Calendrier;
		this.listeDesDemandes = this.$refs.ListeDesDemandesComponent as ListeDesDemandes;
		this.situationDesAbsences = this.$refs.SituationDesAbsencesComponent as SituationDesAbsences;
		this.modalDetailAbsence = this.$refs.modalDetailAbsence as ModalDetailAbsence;
		this.modalAjouterAbsence = this.$refs.modalAjouterAbsence as ModalAjouterAbsence;
		this.modalChangerEtatAbsence = this.$refs.modalChangerEtatAbsence as ModalChangerEtatAbsence;
		this.setModeCalendrier();

    	EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
    		this.initialize();
		});

		if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
			this.initialize();
		}
	}

	public initialize(): void {
		this.paieEnable = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsPaieActive) || ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);

		ServicesFactoryInstance.GestionDesAbsencesService.getSalarieConnecteInfos(data => {
			this.salarieConnecte = data;

			if (this.salarieConnecte.IdNotaire != null) {
				this.estValideurExterne = true;
				this.currentType = TypeCalendrier.EspaceValideurExterne;
			}


			this.aucunUtilisateurAssocie = (this.salarieConnecte == undefined || (this.salarieConnecte.IdContrat == undefined && this.salarieConnecte.IdNotaire == undefined));

    		this.fetchData();
		}, () => this.aucunUtilisateurAssocie = true);

		this.initializeModeManager();
		this.getUrlParameterModeManager();
	}

	//Initialise le mode manager de la page
	private initializeModeManager(): void {
		let user: UtilisateurConnecteDto | undefined = ParametresInstance.utilisateurCourant;

		//Gestion de l'affichage du mode manager
		if (user != undefined && user.IdSalarie !== null && user.IdSalarie !== 0) {
			this.isSwitchManagerVisible = user.EstValideurConges;
		} else {
			this.isSwitchManagerVisible = false;
		}

		//Gestion de l'activation du mode manager
		//Il existe des cas où on cache le mode manager mais on l'active quand même
		if (user != undefined && user.Id !== null && user.EstValideurConges) {
			this.isModeManager = true;
		} else {
			this.isModeManager = false;
		}
	}

	//Récupération des paramètres dans l'url pour initialiser le mode manager
	private getUrlParameterModeManager() {
		const urlString = window.location.hash.split("?");
		const urlParams = new URLSearchParams(urlString[1]);
		if (urlParams.get("isModeManager") === "true" && this.isSwitchManagerVisible === true) {
			this.isModeManager = true;
			urlParams.delete("isModeManager");
			window.history.replaceState(null, document.title, urlString[0]);
		}
	}

	public fetchData(): void {
		if (!this.aucunUtilisateurAssocie && this.salarieConnecte != undefined) {
			if (this.listeDesDemandes == undefined) {
				this.listeDesDemandes = this.$refs.ListeDesDemandesComponent as ListeDesDemandes;
			}
			this.listeDesDemandes.fetchData();

			if (this.situationDesAbsences == undefined) {
				this.situationDesAbsences = this.$refs.ListeDesDemandesComponent as SituationDesAbsences;
			}
			this.situationDesAbsences.fetchData();
			this.setModeCalendrier();
		}

		ServicesFactoryInstance.StatuAbsenceService.getEquipe(data => {
			this.listeEquipe = data;
			this.dataReady -= 1;
			this.anyTeam = data.length > 0;
			this.loadCalendar = false;
		}, () => this.dataReady -= 1);
	}

	@Watch("isModeManager")
	public setModeCalendrier(): void {
		if (this.calendrier == undefined) {
			this.calendrier = this.$refs.calendrierComponent as Calendrier;
		}

		if (this.calendrier == undefined) {
			return;
		}

		if (this.isModeManager) {
			this.currentType = (this.estValideurExterne ? this.typeCalendrierEspaceValideurExterne : this.typeCalendrierEspaceSalarie);
		}
		else {
			this.currentType = this.typeCalendrierEspaceSalarie;
		}
		this.calendrier.changeType(this.currentType);
	}

	public toggleModeManager(): void {
		this.isModeManager = !this.isModeManager;
	}

	// ------------------------------------------------------------------------------- MODALS DISPLAY

	public afficherModalDetailAbsence(data: any): void {
		if (this.modalDetailAbsence == undefined) {
			this.modalDetailAbsence = this.$refs.modalDetailAbsence as ModalDetailAbsence;
		}

		if (this.modalDetailAbsence == undefined) {
			return;
		}

		this.modalDetailAbsence.init(data.absence);

		$("#modalDetailAbsence").modal("show");
	}

	public afficherModalAjouterAbsence(): void {
		if (this.modalAjouterAbsence == undefined) {
			this.modalAjouterAbsence = this.$refs.modalAjouterAbsence as ModalAjouterAbsence;
		}

		if (this.modalAjouterAbsence == undefined) {
			return;
		}

		if (this.salarieConnecte != undefined && this.salarieConnecte.IdContrat != undefined && this.salarieConnecte.IdSalarie != undefined) {
			this.modalAjouterAbsence.init(ModeOuvertureAbsence.AbsenceSalarieParSalarie, undefined, this.salarieConnecte.IdSalarie);
		}

		$("#modalAjouterAbsence").modal("show");
	}

	public afficherModalChangerEtatAbsence(absence: AbsenceSalarieDto, action: ActionAbsencesEnum): void {
		if (this.modalChangerEtatAbsence == undefined) {
			this.modalChangerEtatAbsence = this.$refs.modalChangerEtatAbsence as ModalChangerEtatAbsence;
		}
		if (this.modalChangerEtatAbsence == undefined) {
			return;
		}

		this.modalChangerEtatAbsence.init(absence, action);
		$("#modalChangerEtatAbsence").modal("show");
	}

	// ------------------------------------------------------------------------------- MODALS PROCESSING

	public enregistrerAbsenceOk(absence: AbsenceSalarieDto): void {
		this.fetchData();
	}

	public changerEtatAbsenceOk(absence: AbsenceSalarieDto): void {
		this.fetchData();
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/gestionDesAbsences.ts